export default __webpack_public_path__ + "static/media/mood_alt.13ee75fa.svg";